/** Shared table UX defaults — search, pagination, rows-per-page limit */
export const DEFAULT_ROWS_PER_PAGE = 10;

export const ROWS_PER_PAGE_OPTIONS = [5, 10, 25, 50, 100] as const;
